<header id="headadmin">
    <app-header></app-header>
    <app-navbar></app-navbar>
  </header>
  <body>
    <div class="card">
      <!--div *ngIf="VariableParametrica.nombre == 'Superintendencia'" class="card-header text-center" style="background-color: #be0c4d;">
        <h4 style="color: white;">Superintendencia</h4>
      </div>
      <div *ngIf="VariableParametrica.nombre == 'Tipo Entidad'" class="card-header text-center" style="background-color: #be0c4d;">
        <h4 style="color: white;">Tipo Entidad</h4>
      </div>
      <div *ngIf="VariableParametrica.nombre != 'Tipo Entidad' && VariableParametrica.nombre != 'Superintendencia'" class="card-header text-center" style="background-color: #be0c4d;">
        <h4 style="color: white;">{{VariableParametrica.nombre}}</h4>
      </div>
      <div class="card-header text-center" style="background-color: #be0c4d;">
        <h4 style="color: white;">{{VariableParametrica.nombre}}</h4>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-auto">
            <a type="a" class="btn btn-secondary" href="parametricas">Volver</a>
          </div>
          <div *ngIf="VariableParametrica.descrip != 'Divipola'" class="col-auto">
            <a type="a" class="btn btn-primary"  style="color: white;" (click)="NuevaVariable()">+ Nueva</a>
          </div>
        </div>
        <div *ngIf="VariableParametrica.descrip != 'Divipola'" class="container">
          <form>
            <div class="col-7">
                <div class="row">
                    <div class="row">
                        <div *ngIf="VariableParametrica.nombre == 'Tipo Entidad'" class="col-6">
                            <div><label><b>Superintendencia: </b></label></div>
                            <div><select class="form-select" aria-label="Default select example" name="super" [(ngModel)]="VariableNueva.codsuper" [disabled]="NuevaVar">
                                <option selected value="0">Seleccionar</option>
                                <option *ngFor="let super of Superintendencias" value="{{super.codigo}}">{{super.nombre}}</option>
                                </select></div>
                        </div>
                        <div class="col-6">
                            <div><label><b>Código: </b></label></div>
                            <div><input class="form-control" name="codigo" [(ngModel)]="VariableNueva.codigo" [disabled]="CodigoDisabled"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div><label><b>Nombre: </b></label></div>
                            <div><input class="form-control" name="nombre" [(ngModel)]="VariableNueva.nombre" [disabled]="NuevaVar"></div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row justify-content-md-center">
                    <button type="button" class="btn btn-primary col-2" (click)="GuardarNuevaVarible()" [disabled]="NuevaVar">Guardar</button>
                </div>
            </div>
          </form>
        </div>
        <br>
        <div class="container-fluid" style="align-content: center;">
          <table *ngIf="VariableParametrica.descrip != 'Divipola'" class="table table-bordered">
            <thead>
              <th>Código</th>
              <th>Nombre</th>
              <th>Opción</th>
            </thead>
            <tbody>
              <tr *ngFor="let s of ListadoVaribles | paginate:{ itemsPerPage: 5, currentPage: page }">
                <td>{{s.codigo}}</td>
                <td>{{s.nombre}}</td>
                <td style="text-align: center;"><a type="button" class="fa fa-edit" data-toggle="modal" data-target="#modalEditar"
                  data-bs-toggle="tooltip" data-bs-placement="right" title="editar de superintendencia"
                  (click)="EditarVariable(s)" style="color: green;"></a></td>
              </tr>
            </tbody>
          </table>
          <table *ngIf="VariableParametrica.descrip == 'Divipola'" class="table table-bordered">
            <thead>
              <th>No.</th>
              <th>Código Departamento</th>
              <th>Departamento</th>
              <th>Código Municipio</th>
              <th>Municipio</th>
            </thead>
            <tbody>
              <tr *ngFor="let s of ListadoDivipola | paginate:{ itemsPerPage: 10, currentPage: page }">
                <td>{{s.id}}</td>
                <td>{{s.coddepto}}</td>
                <td>{{s.departamento}}</td>
                <td>{{s.codmpio}}</td>
                <td>{{s.nommpio}}</td>
              </tr>
            </tbody>
          </table>
          <div class="row justify-content-center">
            <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
          </div>
        </div>
      </div>
    </div>
  </body>

  <div class="modal fade bd-example-modal-lg" id="modalEditar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="background-color: #be0c4d;">
          <h5 class="modal-title" id="modalEditar" style="color: white;">Editar Superintendencia</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card-body container-fluid">
            <form>
              <div class="col-9" style="margin: auto;">
                <div class="row">
                    <div class="row">
                        <div *ngIf="VariableParametrica.nombre == 'Tipo Entidad'" class="col-6">
                            <div><label><b>Superintendencia: </b></label></div>
                            <div><select class="form-select" aria-label="Default select example" name="super" [(ngModel)]="VariableEditar.codsuper" [disabled]="EditarVar">
                                <option selected value="{{SuperTipoEntEdit.codigo}}">{{SuperTipoEntEdit.nombre}}</option>
                                <option *ngFor="let super of Superintendencias" value="{{super.codigo}}">{{super.nombre}}</option>
                                </select></div>
                        </div>
                        <div class="col-6">
                            <div><label><b>Código: </b></label></div>
                            <div><input class="form-control" name="codigo" [(ngModel)]="VariableEditar.codigo" [disabled]="CodigoEditDisabled"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div><label><b>Nombre: </b></label></div>
                            <div><input class="form-control" name="nombre" [(ngModel)]="VariableEditar.nombre" [disabled]="EditarVar"></div>
                        </div>
                    </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="GuardarVariableEditada()">Guardar</button>
        </div>
      </div>
    </div>
  </div-->
